module.exports = __webpack_public_path__ + "img/icon-data-active.c2b70730.svg";